import React from "react";
import * as _ from "lodash";
import { Typography } from "@material-ui/core";
import HeaderCash from "./HeaderCash";
import BodyCash from "./BodyCash";
import BodyCashier1 from "./BodyCashier1";
import FooterCash from "./FooterCash";
function DefaultCashairCon(props) {
    const { locInv, found, sta, inv, data, onUnmountComplete, premiApp } = props;

    return (
        <Typography component="div" justifyContent='center'>
                  <div item container justifyContent='center'>
            <HeaderCash
                info={found}
                onUnmountComplete={onUnmountComplete} />
            {premiApp?.cashirTemplate == 6 ?
                (
                    <BodyCash
                        data={data ?? []}
                        sta={sta}
                        locInv={locInv}
                        inv={inv}
                        onUnmountComplete={onUnmountComplete}
                    />
                ) :
                (
                    <BodyCashier1
                        data={data ?? []}
                        sta={sta}
                        locInv={locInv}
                        inv={inv}
                        onUnmountComplete={onUnmountComplete}
                    />
                )}

            <FooterCash found={found} inv={inv} sta={sta} locInv={locInv} onUnmountComplete={onUnmountComplete} />
        </div>
        </Typography>
    );
}
export default DefaultCashairCon;
